import { HStack, Text, Spinner, Badge } from '@chakra-ui/react'
import { Home, Users } from 'lucide-react'
import { usePropertyStats } from '../hooks/useProperties'

interface PropertyStatsProps {
  residenceId: string
  onUnitsClick?: () => void
  onOwnersClick?: () => void
}

export function PropertyStats({ residenceId, onUnitsClick, onOwnersClick }: PropertyStatsProps) {
  const { data: stats, isLoading } = usePropertyStats(residenceId)

  if (isLoading) {
    return <Spinner size="sm" />
  }

  return (
    <HStack gap={3}>
      <Badge
        size="sm"
        variant="subtle"
        colorPalette="blue"
        cursor="pointer"
        onClick={(e) => {
          e.stopPropagation()
          onUnitsClick?.()
        }}
        _hover={{ bg: 'blue.100' }}
        display="flex"
        alignItems="center"
        gap={1}
        px={2}
        py={1}
      >
        <Home size={12} />
        <Text fontSize="xs" fontWeight="medium">
          {stats?.unitsCount || 0} {stats?.unitsCount === 1 ? 'lot' : 'lots'}
        </Text>
      </Badge>

      <Badge
        size="sm"
        variant="subtle"
        colorPalette="green"
        cursor="pointer"
        onClick={(e) => {
          e.stopPropagation()
          onOwnersClick?.()
        }}
        _hover={{ bg: 'green.100' }}
        display="flex"
        alignItems="center"
        gap={1}
        px={2}
        py={1}
      >
        <Users size={12} />
        <Text fontSize="xs" fontWeight="medium">
          {stats?.ownersCount || 0} {stats?.ownersCount === 1 ? 'copropriétaire' : 'copropriétaires'}
        </Text>
      </Badge>
    </HStack>
  )
}
